// Reference: https://docs.google.com/document/d/1U8EReJ_lQcymhWVsVAwXfWkn5u3k0fWvI4RMmLI0AiQ/edit

export type SensitiveDataSelectionState = { [key in SensitiveDataType]: boolean };

export enum SensitiveDataType {
  // Geographic Scope
  EU_DATA = 'EU_DATA',
  US_DATA = 'US_DATA',

  // Sensitive Content
  SENSITIVE_CONTENT_OBSCENE = 'SENSITIVE_CONTENT_OBSCENE',
  SENSITIVE_CONTENT_VIOLENT = 'SENSITIVE_CONTENT_VIOLENT',
  SENSITIVE_CONTENT_DEFAMATORY = 'SENSITIVE_CONTENT_DEFAMATORY',
  SENSITIVE_CONTENT_WEAPONS = 'SENSITIVE_CONTENT_WEAPONS',
  SENSITIVE_CONTENT_TERROR = 'SENSITIVE_CONTENT_TERROR',
  SENSITIVE_CONTENT_PUBLICITY_RIGHTS = 'SENSITIVE_CONTENT_PUBLICITY_RIGHTS',

  // HIPAA
  HIPAA_VENDOR = 'HIPAA_VENDOR',
  HIPAA_ATTACHMENTS = 'HIPAA_ATTACHMENTS',
  HIPAA_RESPONSES = 'HIPAA_RESPONSES',

  // Personal Data Options
  PII = 'PII',
  PERSONAL_TRAITS = 'PERSONAL_TRAITS',

  // Others
  FINANCIAL_INST = 'FINANCIAL_INST',
  OWNERSHIP = 'OWNERSHIP',
}
